<template>
  <div id="timer">
    <i class="fa fa-clock mr-2"></i>
    <span id="minutes">{{ minutes }}</span>
    <span id="middle">:</span>
    <span id="seconds">{{ seconds }}</span>
  </div>
</template>
<script>
export default {
    name: 'Timer',
    data: () => {
        return {
            timer: null,
            totalTime: null,
        }
    },
    computed: {
        minutes: function() {
            const minutes = Math.floor(this.totalTime / 60);
            return this.padTime(minutes);
        },
        seconds: function() {
            const seconds = this.totalTime - (this.minutes * 60);
            return this.padTime(seconds);
        }
    },
    methods: {
        startTimer: function() {
            this.timer = setInterval(() => this.countup(), 1000);
            this.resetButton = true;
        },
        padTime: function(time) {
            return (time < 10 ? '0' : '') + time;
        },
        countup() {
            this.totalTime++;
        }
    },
    created() {
        this.$store.commit('gestion/SET_INICIO_GESTION', this.$moment(parseInt(localStorage.getItem('inicioGestion'))*1000).format('YYYY-MM-DD HH:mm:ss'))
        const duration = this.$moment.duration( (this.$moment(new Date())).diff(this.$moment(parseInt(localStorage.getItem('inicioGestion'))*1000) ))
        this.totalTime = (duration._data.minutes * 60) + duration._data.seconds
    },
    mounted() {
        this.startTimer()
    }
}
</script>